import { mainnet } from 'viem/chains';

import { Avatar } from '@/ui/Avatars/Avatar';

import { DiscoveryTokenResult } from '@/utils/discovery/types';
import { makeImageProxyUrl } from '@/utils/search';

export const issuerLogoOverride: Record<string, string | undefined> = {
  'Tether Holdings': '/images/issuers/tether.webp',
  'Ethena': '/images/issuers/ethena.webp',
  'Aave': makeImageProxyUrl(mainnet.id, '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9'),
  'Binance': '/images/chains/bsc.png',
  'Falcon Finance': makeImageProxyUrl(mainnet.id, '0xfa2b947eec368f42195f24f36d2af29f7c24cec2'),
  'Paxos': '/images/issuers/paxos.webp',
};

export function IssuerCell({ item }: { item: DiscoveryTokenResult }) {
  const { issuer } = item;

  if (issuer == null || issuer.name === 'unknown') {
    return '-';
  }

  const issuerLogo = issuerLogoOverride[issuer.name] ?? issuer.logo ?? undefined;

  return (
    <div className="flex flex-row gap-1.5 items-center max-w-[250px]">
      <Avatar src={issuerLogo} fallbackSrc="/images/chains/none.svg" size={16} />
      <p className="truncate">{issuer?.name ?? '-'}</p>
    </div>
  );
}
